/**
 * A simple mapping of url to module uid (url). This allows us to save some
 * state when going navigating through visited views. Note, this
 * implementation cannot tell two different views with the same url apart.
 * In the situation the views with the same url will use the same
 * module.
 *
 * @constructor
 */
const SimpleBrowserHistory = function() {
  /**
   * Map of uid to browser view data.
   *
   * @type {Object.<number, Object>}
   * @private
   */
  this._uidToData = {};
};

Object.assign(SimpleBrowserHistory.prototype, {
  /**
   * Add state data for the current view.
   *
   * @param {Object} data Data for the browser view.
   */
  add(data) {
    let uid = this.getCurrentUid();
    uid = uid !== null ? uid : this._getNewUid();
    this._uidToData[uid] = data;
  },

  /**
   * Provides the id for the current browser view.
   */
  getCurrentUid() {
    return window.location.href;
  },

  /**
   * Get a id for the current browser view. This uses the href as the id.
   *
   * @return {string} An id for the current browser view.
   * @private
   */
  _getNewUid() {
    return window.location.href;
  },

  /**
   * Get the saved data for the current view.
   *
   * @return {Object} Data stored for the current view.
   */
  getCurrent() {
    return this._uidToData[this.getCurrentUid()];
  },

  /**
   * Get the saved data for the view with the id.
   *
   * @param {string} uid Id for the view.
   * @return {Object} Data stored for the view.
   */
  get(uid) {
    return this._uidToData[uid];
  },

  /**
   * Get the number of HistoryRecords in the cache.
   *
   * @return {number} Number of HistoryRecords in the cache.
   */
  getHistoryRecordCount() {
    return Object.keys(this._uidToData).length;
  },
});

export default SimpleBrowserHistory;
